/** Full-color section icon, matching the old app's native emoji treatment. */
export function EmojiIcon({ emoji, size = 18, className = '' }) {
  return <span className={`emoji-icon ${className}`.trim()} style={{ fontSize: `${size}px` }} aria-hidden="true">{emoji}</span>;
}
